
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

const LOCALES = {
    "no-data": {
        fr: "Aucune donnée pour cette sélection.",
        en: "No data found."
    }
};

class SimpleGrid extends Component {
    constructor(props) {
        super(props);

        //
        this.dataSource = [];

        this._isSelected = this._isSelected.bind(this);
    }

    render() {;
        this.dataSource = Object.assign([],this.props.dataSource);

        if (this.props.sort && this.dataSource)
        {
            this._sortDataSource();
        }

        return (
            <div id={this.props.id} className="simpleGrid-wrapper" style={this.props.wrapperStyles}>
                {
                    this._getTable()
                }
            </div>
        );
    }

    _sortDataSource() {
        this.dataSource = _.orderBy(this.dataSource,this.props.sort.map((sort) => sort.field),this.props.sort.map((sort) => sort.dir||'asc'))
    }

    _getTable() {
        if (this.props.dataSource.length > 0)
        {
            return (
                <table className="simpleGrid-table table table-striped table-bordered table-responsive">
                    <thead style={{display:(this.props.headerVisible === false?'none':'')}}>
                        {
                            this._getHeader()
                        }
                    </thead>
                    <tbody>
                        {
                            this._getBody()
                        }
                    </tbody>
                </table>
            );
        }
        else if (this.props.showEmpty)
        {
            return (
                <p>{LOCALES["no-data"][this.props.lang].toString()}</p>
            );
        }
    }

    _getHeader() {
        let allHeaders = [];

        if (this.props.selectable && this.props.idField)
        {
            allHeaders.push(this._getSelectColumnHeader(0));
        }

        let colHeaders = this.props.columns.map((col,idx) => {
            return (
                <th key={allHeaders.length + idx} className="simpleGrid-header-col">{col.title}</th>
            )
        });

        allHeaders = allHeaders.concat(colHeaders);

        return <tr>{allHeaders.map((headerCell) => headerCell)}</tr>;
    }

    _getSelectColumnHeader(id) {
        return (
            <th key={id} className="simpleGrid-header-col simpleGrid-header-col-checkbox">
            {
                (this.props.selectAll)
                ?
                <input type="checkbox" onChange={this._selectAllRows.bind(this)}></input>
                :
                null
            }
            </th>
        )
    }

    _getSelectCell(idx,value,isEnabled) {
        return (
            <td key={idx} className="simpleGrid-cell simpleGrid-cell-checkbox">
            {
                <input type="checkbox" className={isEnabled === false?'disabled':''} onChange={isEnabled === true?this._selectRow.bind(this):null} value={value} checked={(this._isSelected(value)?'checked':'')}></input>
            }
            </td>
        )
    }

    _isSelected(val)
    {
        if (this.props.selectedIds && this.props.selectedIds.indexOf(val) >= 0)
        {
            return true;
        }
        else
        {
            return false;
        }
    }

    _getBody() {
       return this.dataSource.map((rowData, idx) => {
            let isEnabled = true;

            if (this.props.enabledIds && this.props.enabledIds.indexOf(rowData[this.props.idField]) === -1)
            {
                isEnabled = false;
            }
            else
            {
                isEnabled = true;
            }

            return (
                <tr key={idx} className={"simpleGrid-row " + (isEnabled === false?'disabled':'')}>
                {
                    this._getRowCells(rowData,isEnabled)
                }
                </tr>
            );
        });
    }

    _getRowCells(rowData,rowEnabled) {
        let allRowCells = [];
        
        if (this.props.selectable && this.props.idField)
        {
            allRowCells.push(this._getSelectCell(0,rowData[this.props.idField],rowEnabled));
        }

        let dataRowCells = this.props.columns.map((col,idx) => {
            return (
                <td key={allRowCells.length + idx} className="simpleGrid-cell">{this._getDataCellTemplate(col,rowData)}</td>
            );
        });
        
        allRowCells = allRowCells.concat(dataRowCells);

        return allRowCells.map((rowCell) => rowCell);
    }

    _getDataCellTemplate(col,rowData)
    {
        if (col.template)
        {
            return <div className="simpleGrid-cell-value">{col.template(col,rowData)}</div>
        }
        else
        {
            return <div className="simpleGrid-cell-value">{rowData[col.field]}</div>
        }
    }

    _getColumnTemplateForField(colConfig, dataItem) {
        var wrapperClass = [];

        if (dataItem.errors)
        {
            dataItem.errors.forEach((error,idx) => {
                wrapperClass.push('bg-'+error.type);
                wrapperClass.push('alert-'+error.type);
            },this)
        }
        return `
            <div class="${wrapperClass.join(' ')}" style="display:flex; ${dataItem.indent ? 'padding-left:' + dataItem.indent + 'px':''}">
                ${dataItem.errors?
                    `<span role="button" data-toggle="popover" data-trigger="hover" title="Erreur" data-placement="top" data-container="body" data-content="${dataItem.errors.hierarchical.msg}"></span>&nbsp;`:''
                }
                <div style="margin-right:10px;">${dataItem.code}</div>
                <div style="width:100%;">${dataItem.label}</div>
            </div>`
    }

    _selectAllRows(e) {
        /* TO-DO */
    }

    _selectRow(e) {
        this.props.onSelectionChange(e.target.value,e.target.checked);
    }
}

SimpleGrid.propTypes = {
    "columns": PropTypes.array.isRequired,
    "idField": PropTypes.string.isRequired,
    "lang": PropTypes.string.isRequired,
    "dataSource": PropTypes.array.isRequired,
    "showEmpty": PropTypes.bool,
    "sort": PropTypes.array,
    "selectable": PropTypes.bool,
    "selectAll": PropTypes.bool,
    "selectedIds": PropTypes.array,
    "enabledIds": PropTypes.array,
    "wrapperStyles": PropTypes.object
};

export default SimpleGrid